import { useEffect } from 'react';
import { EVENT_TYPE } from 'shared/utils/mixpanel';
import { useTrackEvent } from './useTrackEvent';
export var usePageVersionView = function (spring_doc_id, refer) {
    var trackEvent = useTrackEvent();
    var page = location.pathname;
    var pageArr = page.split('/');
    if (refer === 'Note Page' || refer === 'Unscheduled Interaction Note Page') {
        if (process.env.REACT_APP_LOCAL_CG_ENV) {
            // ['', 'appointment', '017d9e62-3b1e-44f4-be19-67b9560330c3', 'note', '799810d2-a15a-4c4f-9413-70a31b590335']
            pageArr[2] = '[:id]';
            pageArr[4] = '[:id]';
        }
        else {
            // ['admin', 'compass', 'appointment', 'b2b18f54-0457-421f-abb3-7a6f30552002', 'note', '7d4b3b11-ecae-42e5-9de4-aa73be93fcc7']
            pageArr[4] = '[:id]';
            pageArr[6] = '[:id]';
        }
    }
    page = pageArr.join('/');
    useEffect(function () {
        trackEvent(EVENT_TYPE.PAGE_VERSION_VIEWED, page, 'Note', { spring_doc_id: spring_doc_id });
    }, []);
};
